import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

import { PhxDrawerComponent } from './phx-drawer.component';
import { PhxDialogModule } from '../dialog/phx-dialog.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';

@NgModule({
  declarations: [PhxDrawerComponent],
  imports: [CommonModule, FormsModule, A11yModule, PhxDialogModule, PhxIconButtonModule],
  exports: [PhxDrawerComponent],
})
export class PhxDrawerModule {}
